import styled from "styled-components"
import { device } from "../../utils/breakpoints.js"
import { MainColumn } from "components/MainColumn"

export const BreadcrumbsContainer = styled(MainColumn)`
  margin-top: 30px;
  margin-bottom: 30px;
  @media ${device.desktop} {
    flex-direction: row;
    margin-top: 55px;
    margin-bottom: 43px;
  }

  a {
    font-size: 16px;
    font-weight: 400;
    display: flex;
    :first-of-type {
      span {
        display: none;
      }
    }
    :last-of-type {
      pointer-events: none;
      color: #026747;
    }

    span {
      margin-right: 5px;

      @media ${device.desktop} {
        margin-left: 9px;
        color: #3c3c3c;
      }
    }
  }
`
